export const SERVER = process.env.REACT_APP_SERVER || 'http://localhost:5000';
export const PROJECT_NAME= process.env.REACT_APP_PROJECT